import { format, isSameDay, parseISO } from 'date-fns';

export const getAppointmentStatuses = (date, appointments) => {
  const dayAppointments = appointments.filter(apt => {
    const appointmentDate = parseISO(apt.appointment_date);
    return isSameDay(appointmentDate, date);
  });

  if (dayAppointments.length === 0) return null;

  const statusCounts = {
    Upcoming: 0,
    Completed: 0,
    Missed: 0
  };

  dayAppointments.forEach(apt => {
    statusCounts[apt.status_display]++;
  });

  return statusCounts;
};

export const formatDateForAPI = (date) => {
  return format(date, 'yyyy-MM-dd');
};